import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "branding"
    }}>{`Branding`}</h1>
    <p>{`To ensure users know they are interacting with your plugin, include branding throughout the plugin experience. Below are some examples.`}</p>
    <ul>
      <li parentName="ul">{`Onboarding and branding`}</li>
      <li parentName="ul">{`Customized plugin UI`}</li>
    </ul>
    <h2 {...{
      "id": "onboarding-and-branding"
    }}>{`Onboarding and branding`}</h2>
    <h4 {...{
      "id": "best-practices"
    }}>{`Best practices`}</h4>
    <p>{`When the user is interacting with the plugin for the first time for example in the onboarding or login screen, including the plugin logo will help the user identify the plugin in the future. `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "70.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/cb523/Branding-1.webp 320w", "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/797b9/Branding-1.webp 640w", "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/4b075/Branding-1.webp 1280w", "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/f3ff0/Branding-1.webp 1920w", "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/09431/Branding-1.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/72799/Branding-1.png 320w", "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/6af66/Branding-1.png 640w", "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/21b4d/Branding-1.png 1280w", "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/29114/Branding-1.png 1920w", "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/20a65/Branding-1.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/5ebbc0f5bb56b66e8dc0ad0018ebf881/21b4d/Branding-1.png",
            "alt": "Panel branding example",
            "title": "Panel branding example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "70.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/cb523/Branding-2.webp 320w", "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/797b9/Branding-2.webp 640w", "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/4b075/Branding-2.webp 1280w", "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/f3ff0/Branding-2.webp 1920w", "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/09431/Branding-2.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/72799/Branding-2.png 320w", "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/6af66/Branding-2.png 640w", "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/21b4d/Branding-2.png 1280w", "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/29114/Branding-2.png 1920w", "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/20a65/Branding-2.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/9f22d2fe32e3e18a3ec6f5a3404d1292/21b4d/Branding-2.png",
            "alt": "modal branding example",
            "title": "modal branding example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "customized-plugin-ui"
    }}>{`Customized plugin UI`}</h2>
    <h4 {...{
      "id": "best-practices-1"
    }}>{`Best practices`}</h4>
    <p>{`Customizing the UI to include brand colors, will help users distinguish your plugin's interface. `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "70.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/cb523/Branding-3.webp 320w", "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/797b9/Branding-3.webp 640w", "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/4b075/Branding-3.webp 1280w", "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/f3ff0/Branding-3.webp 1920w", "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/09431/Branding-3.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/72799/Branding-3.png 320w", "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/6af66/Branding-3.png 640w", "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/21b4d/Branding-3.png 1280w", "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/29114/Branding-3.png 1920w", "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/20a65/Branding-3.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/e9f4f2073112a02bf63c0dd93eac1e98/21b4d/Branding-3.png",
            "alt": "Panel customization example",
            "title": "Panel customization example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "70.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/cb523/Branding-4.webp 320w", "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/797b9/Branding-4.webp 640w", "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/4b075/Branding-4.webp 1280w", "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/f3ff0/Branding-4.webp 1920w", "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/09431/Branding-4.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/72799/Branding-4.png 320w", "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/6af66/Branding-4.png 640w", "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/21b4d/Branding-4.png 1280w", "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/29114/Branding-4.png 1920w", "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/20a65/Branding-4.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/static/0071e53f43ddc58604ab87f4e978a88b/21b4d/Branding-4.png",
            "alt": "Modal customization example",
            "title": "Modal customization example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      